import { useRequest } from 'ahooks'
import {
  createTask,
  getAgentList,
  getDeviceListByHostId,
  getEmailList,
  getHostList,
  getTaskGroups,
  getTemplateIdList,
  getTemplateList,
  getAttackTypeList,
  getCaseList,
  getCaseIdList,
  getCaseTagList,
  getGlobalParam,
  updateGlobalParam,
  addCaseTemplate,
  getSampleFile,
  getPluginDetail,
  updatePluginDetail,
} from '@/api/container-security/create-task'
import { Message } from '@/components/message'

export * from './step1/utils/helpers'

// 获取任务分组列表
export const useTaskGroup = () => {
  const { runAsync: run } = useRequest(params => getTaskGroups(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取分组列表失败')
    },
  })

  return [run] as const
}

// 获取agent列表
export const useAgentList = () => {
  const { runAsync: run } = useRequest(() => getAgentList(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取agent列表失败')
    },
  })

  return [run] as const
}

// 获取主机列表
export const useHostList = () => {
  const { runAsync: run } = useRequest(() => getHostList(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取主机列表失败')
    },
  })

  return [run] as const
}

// 根据hostId获取设备列表
export const useDeviceListByHostId = () => {
  const { runAsync: run } = useRequest((hostId?: string) => getDeviceListByHostId(hostId), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取设备列表失败')
    },
  })

  return [run] as const
}

// 获取人员邮箱列表
export const useEmailList = () => {
  const { runAsync: run } = useRequest(() => getEmailList(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取人员邮箱列表失败')
    },
  })

  return [run] as const
}

// 创建任务
export const useCreateTask = () => {
  const { runAsync: run, loading } = useRequest(data => createTask(data), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '创建任务失败')
    },
  })

  return [run, loading] as const
}

// 获取模板列表
export const useGetTemplateList = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest(params => getTemplateList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取模板列表失败')
    },
  })

  return [run, loading, data?.data?.total || {}] as const
}

// 获取模板id列表
export const useGetTemplateIdList = () => {
  const { runAsync: run, data } = useRequest(params => getTemplateIdList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取模板id列表失败')
    },
  })

  return [run, data?.data?.templateIds || []] as const
}

// 获取攻击类型列表
export const useGetAttackTypeList = () => {
  const { runAsync: run } = useRequest(params => getAttackTypeList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取攻击类型列表失败')
    },
  })

  return [run] as const
}

// 获取用例列表
export const useGetCaseList = () => {
  const { runAsync: run, loading } = useRequest(params => getCaseList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取用例列表失败')
    },
  })

  return [run, loading] as const
}

// 获取用例id列表
export const useGetCaseIdList = () => {
  const { runAsync: run, data } = useRequest(params => getCaseIdList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取用例id列表失败')
    },
  })

  return [run, data?.data?.resourceIds || []] as const
}

// 获取用例标签列表
export const useGetCaseTagList = () => {
  const { runAsync: run } = useRequest(params => getCaseTagList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取用例标签列表失败')
    },
  })
  return [run] as const
}

// 获取全局参数配置
export const useGetGlobalParam = () => {
  const { runAsync: run } = useRequest(() => getGlobalParam(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取全局参数配置失败')
    },
  })

  return [run] as const
}

// 修改全局参数配置
export const useUpdateGlobalParam = () => {
  const { runAsync: run, loading } = useRequest((data: any) => updateGlobalParam(data), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '修改全局参数配置失败')
    },
  })

  return [run, loading] as const
}

// 添加用例模板
export const useAddCaseTemplate = () => {
  const { runAsync: run, loading } = useRequest(
    (data: {
      name: string
      resourceIds: string[]
      verificationModeIds: number[]
      sceneIds: number[]
    }) => addCaseTemplate(data),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || '添加用例模板失败')
      },
    },
  )

  return [run, loading] as const
}

// 样本文件下载
export const useGetSampleFile = () => {
  const { runAsync: run, loading } = useRequest(
    (params: { resourceId: string; sha256: string }) => getSampleFile(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || '样本文件下载失败')
      },
    },
  )

  return [run, loading] as const
}

// 获取用例详情
export const useGetPluginDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (params: { resourceId: string }) => getPluginDetail(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || '获取用例详情失败')
      },
    },
  )

  return [run, loading] as const
}

// 修改用例详情
export const useUpdatePluginDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (params: { plugin_id: string; param: any[] }) => updatePluginDetail(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || '修改用例详情失败')
      },
    },
  )

  return [run, loading] as const
}
